import { useEffect, useMemo, useState } from 'react';
import './clickable-zone.scss';
import { useSPosStore } from '../../stores/use-spos-store';
import { Vector3 } from 'three';
import emitter, { EVENT_CLICK_TAG } from '../../utils/mitt';
import { useGlobalStore } from '../../stores/use-global-store';
import clsx from 'clsx';

export default function ClickableZone() {
  const { screenPos } = useSPosStore();
  const [offset, setOffset] = useState<Vector3[]>([]);
  const [names] = useState([
    'clickable-1-1',
    'clickable-2-1',
    'clickable-3-1',
    'clickable-4-2',
    'clickable-5-1',
  ]);

  const { camState } = useGlobalStore();
  const shouldHide = useMemo(() => {
    return camState !== 0;
  }, [camState]);

  useEffect(() => {
    let id = 0;
    const anim = () => {
      id = requestAnimationFrame(anim);
      setOffset(
        names.map((n, i) => {
          const spos = screenPos[n];
          return spos
            ? new Vector3(
                ((spos.x + 1) * window.innerWidth) / 2,
                (-(spos.y - 1) * window.innerHeight) / 2,
                0
              )
            : new Vector3(-9999, 0, 0);
        })
      );
    };
    anim();
    return () => {
      cancelAnimationFrame(id);
    };
  }, [screenPos, names]);

  const toState = (name: string) => {
    const index = parseInt(name.split('-')[1]);
    emitter.emit(EVENT_CLICK_TAG, index);
  };

  return (
    <div className="absolute left-0 top-0 w-full h-full pointer-events-none">
      {names.map((name, i) => (
        <div
          key={name}
          className={clsx(
            // 'bg-[rgba(255,0,0,0.5)]',
            'w-[200rem] h-[150rem] absolute -left-[100rem] -top-[75rem] cursor-pointer rounded-[50%]',
            shouldHide ? 'pointer-events-none' : 'pointer-events-auto'
          )}
          style={{
            transform: `translate3d(${offset[i]?.x}px, ${offset[i]?.y}px, 0)`,
            // pointerEvents: 'all',
          }}
          onClick={() => toState(name)}
        ></div>
      ))}
    </div>
  );
}
